import RootLayout from "../components/root_layout";

import AgentPage from "../pages/agent";
import AgentRegisterPage from "../pages/agent/register";
import AgentResultPage from "../pages/agent/result";
import BrainLabPage from "../pages/brainlab";
import PrivacyPage from "../pages/application/privacy";
import ServicePage from "../pages/application/service";
import CouponBoxPage from "../pages/coupons/coupon_box";
import DonationPage from "../pages/donation";
import DonationStep1Page from "../pages/donation/donation_step1";
import DonationStep2Page from "../pages/donation/donation_step2";
import EduClipPage from "../pages/educlip";
import NotFoundPage from "../pages/error/notFound";
import AppLanding from "../pages/landing/app_landing";
import EventLanding from "../pages/landing/event_landing";
import LoginPage from "../pages/login";
import NewsPage from "../pages/news";
import PocketPeace from "../pages/pocket_peace";
import GeulpicSubscriptionPage from "../pages/pocket_peace/geulpic_subscription_page";
import SisaSubscriptionPage from "../pages/pocket_peace/sisa_subscription_page";
import ProductPage from "../pages/product";
import ProductPaymentResultPage from "../pages/product/product_payment_result";
import ProductStep1Page from "../pages/product/product_step1";
import ProductStep2Page from "../pages/product/product_step2";

const routes = [
  {
    path: "/",
    element: <RootLayout />,
    children: [
      { index: true, element: <AppLanding /> },
      { path: "event", element: <EventLanding /> },
      { path: "donation", element: <DonationPage /> },
      { path: "product", element: <ProductPage /> },
      { path: "product_step1", element: <ProductStep1Page /> },
      { path: "product_step2", element: <ProductStep2Page /> },
      { path: "donation_step1", element: <DonationStep1Page /> },
      { path: "donation_step2", element: <DonationStep2Page /> },
      { path: "product_payment_result", element: <ProductPaymentResultPage /> },
      { path: "educlip", element: <EduClipPage /> },
      { path: "application/service", element: <ServicePage /> },
      { path: "application/privacy", element: <PrivacyPage /> },
      { path: "news", element: <NewsPage /> },
      { path: "brainlab", element: <BrainLabPage /> },
      { path: "agent", element: <AgentPage /> },
      { path: "agent/register", element: <AgentRegisterPage /> },
      { path: "agent/result", element: <AgentResultPage /> },
      { path: "pocket_peace", element: <PocketPeace /> },
      { path: "subscribe/geulpic", element: <GeulpicSubscriptionPage /> },
      { path: "subscribe/sisa", element: <SisaSubscriptionPage /> },
      { path: "login", element: <LoginPage /> },
      { path: "coupon_box", element: <CouponBoxPage /> },

      { path: "*", element: <NotFoundPage /> },
    ],
  },
];

export default routes;
